import { render, staticRenderFns } from "./DzCreate.vue?vue&type=template&id=d0d88816&scoped=true"
import script from "./DzCreate.vue?vue&type=script&lang=js"
export * from "./DzCreate.vue?vue&type=script&lang=js"
import style0 from "./DzCreate.vue?vue&type=style&index=0&id=d0d88816&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d88816",
  null
  
)

export default component.exports